/**
 * @param record - the record to be reversed. it should be an object where keys and values are of the same type.
 * @returns a new object where the keys and values of the input record are swapped. entries with undefined values are ignored.
 **/
export function reverseRecord<T extends string | number, U extends string | number | undefined>(
  record: Record<T, U>,
): Record<Exclude<U, undefined>, T> {
  const reversed: Partial<Record<Exclude<U, undefined>, T>> = {};
  for (const key in record) {
    if (Object.prototype.hasOwnProperty.call(record, key)) {
      const value = record[key];
      // skip undefined values
      if (value !== undefined) {
        reversed[value as Exclude<U, undefined>] = key;
      }
    }
  }
  return reversed as Record<Exclude<U, undefined>, T>;
}
